import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComponentBase, RentalObjectInfo } from 't4core';


@Component({
    selector: 't4-objectList',
    templateUrl: './objectList.component.html',
    styleUrls: ['./objectList.component.css'],
})
export class ObjectListComponent extends ComponentBase implements OnInit {
    @Input() locationId: number = this.Settings.clientSettings.RentalLocationId;
    @Input() isOneWay: Boolean = false;
    @Input() includeDisabled: Boolean = false;
    @Input() multiSelect: Boolean = false;

    @Output() selectionChanged: EventEmitter<RentalObjectInfo[]> = new EventEmitter<RentalObjectInfo[]>();


    public availableCategories: string[] = [];
    public availableObjects: any = {};
    public selectedObjects: RentalObjectInfo[] = [];

  public rentalObjects: RentalObjectInfo[] = [];

  public isLoading: boolean = false;

    constructor() {
        super();
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.loadData();
    }

    public toggle(object: RentalObjectInfo, fromCheckbox: boolean = false) {
        if (this.multiSelect && !fromCheckbox) return;
        if (!this.multiSelect && fromCheckbox) return;

        if (this.selectedObjects.indexOf(object) >= 0) {
            this.selectedObjects.splice(this.selectedObjects.indexOf(object), 1);
        } else {
            if (!this.multiSelect) this.selectedObjects = [];
            this.selectedObjects.push(object);
        }

        this.selectionChanged.emit(this.selectedObjects);
    }

    public async loadData() {
        if (this.loading.objects) return;

        this.isLoading = true;

      // Load data for object tab
      if (this.rentalObjects.length == 0) {
        if (this.Settings.clientSettings.RentalLocationId)
          this.rentalObjects = await this.Api.get<RentalObjectInfo[]>("/RentalObject/GetObjects", { location: this.locationId, oneway: this.isOneWay });
        else
          this.rentalObjects = await this.Api.get<RentalObjectInfo[]>("/RentalObject/GetObjects", { location: this.locationId, oneway: this.isOneWay });
      }
      
      this.availableObjects = {};
      this.availableCategories = [];

      var categoryKeys = {};

      for (var i of this.rentalObjects.sort((a, b) => {
        if (a.CategoryIndex < b.CategoryIndex) return -1;
        if (a.CategoryIndex > b.CategoryIndex) return 1;
        if (a.IsEnabled < b.IsEnabled) return 1;
        if (a.IsEnabled > b.IsEnabled) return -1;
        if (a.Status < b.Status) return -1;
        if (a.Status > b.Status) return 1;
        if (a.Alias < b.Alias) return -1;
        if (a.Alias > b.Alias) return 1;

        return 0;
      })) {
        var category = "Other";
        if (i.Category) category = i.Category;

        if (!categoryKeys[category]) {
          categoryKeys[category] = category.indexOf("Turbo.Data") == 0 ? this.translate(category) : category;
        }

        if (this.includeDisabled || i.IsEnabled) { // Do not display disabled objects
          var cat = categoryKeys[category];
          if (!this.availableObjects[cat]) {
            this.availableCategories.push(cat);
            this.availableObjects[cat] = [];
          }

          this.availableObjects[cat].push(i);
        }
      }


      this.isLoading = false;
    }
}
